import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  reviewImagesButton: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    cursor: 'pointer',
    padding: 0,
    height: 'auto',
    marginLeft: theme.spacing(6),
    fontSize: 12,
    fontWeight: 600,
    '&:hover': {
      background: 'transparent'
    }
  },
  reviewImagesIcon: {
    width: 24,
    height: 24,
    marginRight: theme.spacing(1.5)
  },
  card: {
    backgroundColor: theme.colorPalette.beige_25,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: 72,
    padding: '0 24px',
    marginBottom: theme.spacing(2)
  },
  titleContainer: {
    display: 'flex',
    flexDirection: 'column'
  },
  title: {
    fontSize: 16,
    fontWeight: 400,
    color: theme.colorPalette.green_90
  },
  subtitle: {
    marginTop: theme.spacing(1),
    fontSize: 12,
    fontWeight: 400,
    color: theme.colorPalette.green_80
  },
  buttons: {
    display: 'flex'
  }
});

export default makeStyles(styles);
